﻿/**
 * This file contains the GlobalEventHandler class which provides global event handling from javascript.
 */
export class GlobalEventHandler {
    private keydownHandlers: Map<string, (event: KeyboardEvent) => void> = new Map();

    /**
     * Registers a global keydown event listener and associates it with the provided .NET reference.
     * @param id - A unique identifier for the listener (e.g., component name or ID).
     * @param dotNetRef - A DotNetObjectReference to the Blazor component.
     */
    public async AddKeyDownListener(id: string, dotNetRef) {
        if (this.keydownHandlers.has(id)) {
            console.warn(`A keydown listener with ID '${id}' is already registered.`);
            return;
        }

        const handler = (event: KeyboardEvent) => {
            dotNetRef.invokeMethodAsync('OnKeyDown', event.key);
        };

        this.keydownHandlers.set(id, handler);
        document.addEventListener('keydown', handler);
    }

    /**
     * Removes a specific global keydown event listener by its ID.
     * @param id - The unique identifier for the listener.
     */
    public async RemoveKeyDownListener(id: string) {
        const handler = this.keydownHandlers.get(id);
        if (handler) {
            document.removeEventListener('keydown', handler);
            this.keydownHandlers.delete(id);
        } else {
            console.warn(`No keydown listener found with ID '${id}' to remove.`);
        }
    }

    /**
     * Removes all registered global keydown event listeners.
     */
    public async RemoveAllKeyDownListeners() {
        this.keydownHandlers.forEach((handler, id) => {
            document.removeEventListener('keydown', handler);
        });
        this.keydownHandlers.clear();
    }
}

window['GlobalEventHandler'] = new GlobalEventHandler();